var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarMid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3226",
    "data-name": "Rectangle 3226",
    width: 120,
    height: 120,
    transform: "translate(729 -269)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3059",
    "data-name": "Rectangle 3059",
    width: 375,
    height: 96.07,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_17",
    x: -140,
    y: 9,
    width: 399,
    height: 119.07,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.039
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_16",
    x: -149,
    y: 0,
    width: 417,
    height: 137.07,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.039
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23926",
    "data-name": "Mask Group 23926",
    transform: "translate(-729 269)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28634",
    "data-name": "Group 28634",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37921",
    "data-name": "Path 37921",
    d: "M359.49,23.97l-124.59.06q-.72,0-1.44-.06a19.956,19.956,0,0,1-14.39-7.72.47.47,0,0,1-.06-.09c-.08-.1-.16-.21-.24-.31a38.515,38.515,0,0,0-61.54,0c-.08.1-.16.21-.24.31a.47.47,0,0,1-.06.09,19.956,19.956,0,0,1-14.39,7.72q-.72.06-1.44.06L16.51,23.97A16.013,16.013,0,0,0,.5,39.98V79.56A16.013,16.013,0,0,0,16.51,95.57H359.49A16.013,16.013,0,0,0,375.5,79.56V39.98A16.013,16.013,0,0,0,359.49,23.97Z",
    transform: "translate(600.5 -242.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28570",
    "data-name": "Group 28570",
    transform: "translate(-722 4047)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1451, -4314)",
    filter: "url(#Union_17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_17-2",
    "data-name": "Union 17",
    d: "M187.5,95.07H16.01q-.758,0-1.5-.069H0V39.48A16.013,16.013,0,0,1,16.01,23.47l124.59.059q.721,0,1.44-.059a19.956,19.956,0,0,0,14.39-7.72.476.476,0,0,0,.06-.09c.08-.1.16-.21.239-.31a38.515,38.515,0,0,1,61.54,0c.08.1.16.21.24.31a.437.437,0,0,0,.06.09,19.954,19.954,0,0,0,14.389,7.72q.721.059,1.44.059L358.99,23.47A16.013,16.013,0,0,1,375,39.48V95H360.488q-.74.069-1.5.069Z",
    transform: "translate(-128 25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1451, -4314)",
    filter: "url(#Union_16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_16-2",
    "data-name": "Union 16",
    d: "M187.5,95.07H16.01q-.758,0-1.5-.069H0V39.48A16.013,16.013,0,0,1,16.01,23.47l124.59.059q.721,0,1.44-.059a19.956,19.956,0,0,0,14.39-7.72.476.476,0,0,0,.06-.09c.08-.1.16-.21.239-.31a38.515,38.515,0,0,1,61.54,0c.08.1.16.21.24.31a.437.437,0,0,0,.06.09,19.954,19.954,0,0,0,14.389,7.72q.721.059,1.44.059L358.99,23.47A16.013,16.013,0,0,1,375,39.48V95H360.488q-.74.069-1.5.069Z",
    transform: "translate(-128 25)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarMid);
export default __webpack_public_path__ + "static/media/navbar-mid.85baae45eba5f1630b9a1e4b2ee72067.svg";
export { ForwardRef as ReactComponent };